import React from 'react'
import '../styles/services.css';

function Services(){
    return(
        <div className="services_wrapper page_content">
            <h1>Our Services</h1>
            <div className="service_items">
                <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-4">
                        <div className="service_item">
                            <div className="item_image"><img src="../../assets/infrastructure.jpg" alt="NoImage"/></div>
                            <div className="item_title"><h3>Networking and Infrastructure Solutions</h3></div>
                            <div className="item_description">Smart Khalanga Solutions (Pty) Ltd has expertise in new site surveys including
                            network and infrastructure planning of computer and network (Voice and Data)
                            cabling installations, installation of servers, cabling from switches to LAN points
                            and/ or WIFI modems.</div>
                            <div className="item_link"><a href="/services/network-and-infrastructure" className="view">View</a></div>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="service_item">
                            <div className="item_image"><img src="../../assets/sourcing.jpg" alt="NoImage"/></div>
                            <div className="item_title"><h3>Strategice Sourcing and Supply Chain</h3></div>
                            <div className="item_description">Smart Khalanga Solutions (Pty) Ltd has extensive experience in the sourcing
                            and supply of in a very broad range of IT related assets and have no limit to
                            what the company can do.</div>
                            <div className="item_link"><a href="/services/sourcing-and-supply-chain" className="view">View</a></div>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="service_item">
                            <div className="item_image"><img src="../../assets/computing.jpg" alt="NoImage"/></div>
                            <div className="item_title"><h3>Client Computing Management</h3></div>
                            <div className="item_description">We provide bespoke solutions for your company needs</div>
                            <div className="item_link"><a href="/services/client-computing-management" className="view">View</a></div>
                        </div>
                    </div>
                    
                </div>

                <div className="row second">
                    <div className="col-lg-4">
                        <div className="service_item">
                            <div className="item_image"><img src="../../assets/server.jpg" alt="NoImage"/></div>
                            <div className="item_title"><h3>Server Infrastructure Implementation and Management</h3></div>
                            <div className="item_description">Server management form an integral part of our portfolio. We possess skills in confi guration,
                            virtual and physical management including the installation of complex software and the distribution
                            of security updates, patches and release management.</div>
                            <div className="item_link"><a href="/services/server-infrastructure-implementation" className="view">View</a></div>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="service_item">
                            <div className="item_image"><img src="../../assets/serve.jpg" alt="NoImage"/></div>
                            <div className="item_title"><h3>Email Services, Collaboration and Website Management</h3></div>
                            <div className="item_description">Internal and external communication is the life fl ow of any organizations’ operational success.
                            Smart KS understands this critical requirement and has thus acquire skills and capabilities in the
                            management of communication systems with the organisation.</div>
                            <div className="item_link"><a href="/home" className="view">View</a></div>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="service_item">
                            <div className="item_image"><img src="../../assets/service.jpg" alt="NoImage"/></div>
                            <div className="item_title compensate"><h3>Service Desk Management</h3></div>
                            <div className="item_description">Smart KS has experience in the scoping, set up, deployment and management of
                            service desks. The solution can be tailored to both the public and private sector.
                            This will be accomplished using ITIL framework guideline of service management.
                            This will ensure that the operations are managed within the stipulated service
                            levels.</div>
                            <div className="item_link"><a href="/services/service-desk-management" className="view">View</a></div>
                        </div>
                    </div>
                    </div>
            </div>
            </div>
            
        </div>
    );
}

export default Services